import { DecimalPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ProductAttrValueSelect } from '../../../components/product/product-attr-value-select/product-attr-value-select';
import { ProductDescriptions } from '../../../components/product/product-descriptions/product-descriptions';
import { ProductImagesCarousel } from '../../../components/product/product-images-carousel/product-images-carousel';
import { ProductLocation } from '../../../components/product/product-location/product-location';
import { ProductRecommendedList } from '../../../components/product/product-recommended-list/product-recommended-list';
import { ProductSizeTableButton } from '../../../components/product/product-size-table-button/product-size-table-button';
import { UnlockProductPriceCard } from '../../../components/product/unlock-product-price-card/unlock-product-price-card';
import { AddToCartButton } from '../../../components/shopping/add-to-cart-button/add-to-cart-button';
import { Product, ProductAttrValue } from '../../../models/product';
import { ProductApiService } from '../../../services/apis/product-api.service';
import { AuthService } from '../../../services/auth.service';
import { TitleService } from '../../../services/title.service';
import { mergeRouter } from '../../../utils/router';

@Component({
  selector: 'app-product-page',
  imports: [
    ProductImagesCarousel,
    MatIconModule,
    RouterModule,
    ProductLocation,
    DecimalPipe,
    ProductAttrValueSelect,
    MatButtonModule,
    ProductDescriptions,
    ProductSizeTableButton,
    ProductRecommendedList,
    AddToCartButton,
    MatTooltipModule,
    UnlockProductPriceCard
  ],
  templateUrl: './product-page.html',
  styleUrl: './product-page.scss',
})
export class ProductPage implements OnInit {
  loading: boolean = false;
  product?: Product;
  attrs: ProductAttrValue[] = [];
  pricedAttrValue?: ProductAttrValue;
  constructor(
    private route: ActivatedRoute,
    private title: TitleService,
    private productApi: ProductApiService,
    private router: Router,
    private auth: AuthService,
  ) {
    this.title.setTitle('');
  }

  get free_shipping_threshold() {
    return environment.free_shipping_threshold;
  }

  get is_authenticated() {
    return this.auth.profile() != null;
  }

  queryAttrValueIDs: number[] = [];
  queryPricedAttrValueID: number = 0;

  get deliveryDate() {
    const date = new Date();
    date.setDate(date.getDate() + 7);
    const from = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
    date.setDate(date.getDate() + 3);
    const to = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
    return `${from} - ${to}`;
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const no = params['no'] ?? '';
      this.getProduct(no);
    });
    this.route.queryParams.subscribe((params) => {
      const attr_value_ids = params['attr_ids'];
      if (attr_value_ids instanceof Array) {
        this.queryAttrValueIDs = attr_value_ids.map((v: string) => parseInt(v));
      } else if (attr_value_ids) {
        this.queryAttrValueIDs = [parseInt(attr_value_ids)];
      }
      this.queryPricedAttrValueID = parseInt(params['priced_attr_id'] ?? '0');
    });
  }

  async getProduct(no: string) {
    try {
      this.loading = true;
      this.product = await this.productApi.getProduct(no);
      this.title.setTitle(this.product.name);

      this.attrs = [];
      outloop: for (const attr of this.product.attrs) {
        for (const value of attr.values) {
          if (this.queryAttrValueIDs.includes(value.id)) {
            this.attrs.push(value);
            continue outloop;
          }
        }
        this.attrs.push(attr.values[0]);
      }
      this.pricedAttrValue = this.product.priced_attr.values[0];

      for (const value of this.product.priced_attr.values) {
        if (value.id === this.queryPricedAttrValueID) {
          this.pricedAttrValue = value;
          break;
        }
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
  selectAttr(index: number, value: ProductAttrValue) {
    this.attrs[index] = value;
    mergeRouter(this.router, this.route, {
      attr_ids: this.attrs.map((v) => v.id),
      priced_attr_id: this.pricedAttrValue?.id,
    });
  }
  selectPricedAttr(value: ProductAttrValue) {
    this.pricedAttrValue = value;
    mergeRouter(this.router, this.route, {
      attr_ids: this.attrs.map((v) => v.id),
      priced_attr_id: this.pricedAttrValue?.id,
    });
  }
}
